import React, { createContext, useReducer, useContext } from "react"

const initialState = {
  currentTheme:"dark",
  cursorType: false,
  cursorStyles: ["pointer", "hovered", "locked", "white"],
  toggleNavigation: false,
  toggleBlog: false,
}
//Define Conext
const GlobalStateContext = createContext(initialState)
const GlobalDispatchContext = createContext()

//Reducer
const globalReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE_THEME": {
      return {
        ...state,
        currentTheme: action.theme,
      }
    }
    case "CURSOR_TYPE": {
      return {
        ...state,
        cursorType: action.cursorType,
      }
    }
    case "TOGGLE_NAVIGATION": {
      return {
        ...state,
        toggleNavigation: action.toggleNavigation,
      }
    }
    case "TOGGLE_BLOG": {
      return {
        ...state,
        toggleBlog: action.toggleBlog,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

//Provider

export const GlobalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(globalReducer, {
    currentTheme: "dark",
    cursorType: false,
    cursorStyles: ["pointer", "hovered", "locked", "white"],
    toggleNavigation: false,
    toggleBlog: false,
  })

  return (
    <GlobalDispatchContext.Provider value={dispatch}>
      <GlobalStateContext.Provider value={state}>
        {children}
      </GlobalStateContext.Provider>
    </GlobalDispatchContext.Provider>
  )
}

//custom hooks for when we want to use our global state
export const useGlobalStateContext = () => useContext(GlobalStateContext)

export const useGlobalDispatchContext = () => useContext(GlobalDispatchContext)
